<template>
  <div id="menu-reports" role="tabpanel" class="tab-pane show" aria-labelledby="reports-tab">
    <div class="submenu-nav-header">
      <div class="my-1 d-lg-none"></div>
      <h4 class="mb-0">Reports</h4>
      <small class="mb-1"><i>Various Reports and Data Exporting</i></small>
    </div>
    <ul class="nav nav-pills" id="submenu-reports" role="tablist">
      <li class="nav-item">
        <a id="sm-history-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('history')}" data-toggle="tab"
           href="#sm-history"
           role="tab" aria-controls="sm-history"
           aria-selected="true">
          <fa-icon icon="file-chart-line"/>&nbsp;&nbsp;History & Debrief</a>
      </li>
      <li class="nav-item">
        <a id="sm-history-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('management')}" data-toggle="tab"
           href="#sm-management"
           role="tab" aria-controls="sm-management"
           aria-selected="true">
          <fa-icon icon="money-check-edit-alt"/>&nbsp;&nbsp;Management</a>
      </li>
      <li class="nav-item">
        <a id="sm-status-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('status')}" data-toggle="tab"
           href="#sm-status"
           role="tab" aria-controls="sm-status"
           aria-selected="true">
          <fa-icon icon="file-chart-line"/>&nbsp;&nbsp;Unit Status</a>
      </li>
      <li class="nav-item">
        <a id="sm-events-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('events')}" data-toggle="tab"
           href="#sm-events"
           role="tab" aria-controls="sm-events"
           aria-selected="true">
          <fa-icon icon="file-chart-line"/>&nbsp;&nbsp;Events</a>
      </li>
    </ul>
    <div class="tab-content">
      <hr class="mt-2">
      <div id="sm-history" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('history')}">
        <div class="row">
          <div v-if="security.can('reports_history', 'debrief_detailed')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportDebriefDetailed.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportDebriefDetailed.icon" :class="menu.reportDebriefDetailed.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportDebriefDetailed.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportDebriefDetailed.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.can('reports_history', 'debrief_summary')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportDebriefSummary.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportDebriefSummary.icon" :class="menu.reportDebriefSummary.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportDebriefSummary.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportDebriefSummary.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div v-if="security.can('reports_history', 'vehicle_analysis')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportVehicleAnalysis.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportVehicleAnalysis.icon" :class="menu.reportVehicleAnalysis.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportVehicleAnalysis.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportVehicleAnalysis.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.can('reports_history', 'position_log')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportPositionLog.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportPositionLog.icon" :class="menu.reportPositionLog.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportPositionLog.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportPositionLog.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row" v-if="security.can('reports_history', 'vehicle_speeding')">
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportVehicleSpeedingDetailed.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportVehicleSpeedingDetailed.icon" :class="menu.reportVehicleSpeedingDetailed.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportVehicleSpeedingDetailed.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportVehicleSpeedingDetailed.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportVehicleSpeedingSummary.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportVehicleSpeedingSummary.icon" :class="menu.reportVehicleSpeedingSummary.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportVehicleSpeedingSummary.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportVehicleSpeedingSummary.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-management" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('management')}">
        <div class="row">
          <div v-if="security.can('reports_management', 'vehicle_expenses')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportVehicleExpenses.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportVehicleExpenses.icon" :class="menu.reportVehicleExpenses.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportVehicleExpenses.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportVehicleExpenses.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.can('reports_management', 'vehicle_maintenance')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportVehicleMaintenance.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportVehicleMaintenance.icon" :class="menu.reportVehicleMaintenance.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportVehicleMaintenance.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportVehicleMaintenance.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-status" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('status')}">
        <div class="row">
          <div v-if="security.can('reports_status', 'status_units_detailed')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportUnitStatusDetailed.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportUnitStatusDetailed.icon" :class="menu.reportUnitStatusDetailed.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportUnitStatusDetailed.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportUnitStatusDetailed.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.can('reports_status', 'status_units_summary')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportUnitStatusSummary.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportUnitStatusSummary.icon" :class="menu.reportUnitStatusSummary.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportUnitStatusSummary.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportUnitStatusSummary.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-events" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('events')}">
        <div class="row">
          <div v-if="security.can('reports_events', 'events_detailed')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportDetailedEvents.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportDetailedEvents.icon" :class="menu.reportDetailedEvents.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportDetailedEvents.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportDetailedEvents.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.can('reports_events', 'events_summary')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportEventsSummary.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportEventsSummary.icon" :class="menu.reportEventsSummary.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportEventsSummary.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportEventsSummary.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="cubes" />&nbsp;Event Pools</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div v-if="security.can('reports_events', 'event_pool_report')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportEventPoolDetailed.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportEventPoolDetailed.icon" :class="menu.reportEventPoolDetailed.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportEventPoolDetailed.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportEventPoolDetailed.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.can('reports_events', 'event_pool_report')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.reportEventPoolSummary.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.reportEventPoolSummary.icon" :class="menu.reportEventPoolSummary.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.reportEventPoolSummary.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.reportEventPoolSummary.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuItems from '@/common/menu'
import security from '@/common/security'

import {
  NAV_GET_MENU_OPEN,
  NAV_SET_MENU_OPEN
} from '@/store/navigation/nav.types'

export default {
  data () {
    return {
      menu: menuItems,
      activeMenuTab: ''
    }
  },

  mounted () {
    if (security.canView('vehicles')) {
      this.activeMenuTab = 'history'
    }
  },

  methods: {
    setMenuState () {
      this.$store.commit(NAV_SET_MENU_OPEN, !this.getMenuState())
    },

    getMenuState () {
      return this.$store.getters[NAV_GET_MENU_OPEN]
    },

    isMenuTabActive (tabName) {
      return tabName === this.activeMenuTab
    }
  },

  components: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/navigation/NavMenuReports.vue